/* Generated by _shopify/build_theme.py from js/main.js: asset addresses, the islands bundle, reel links
   and the contact form (Shopify sends it) differ. Edit js/main.js and run the script again. */
/* Neurokierunek — scroll scenes, calm mode and small interactions.
   Films are image sequences drawn to a canvas. They only move while the visitor scrolls. */
(() => {
  'use strict';

  const root = document.documentElement;
  // Theme assets: one flat folder, worked out from this script's own URL (Shopify's asset_url).
  const script = document.currentScript;
  const BASE = new URL('.', script ? script.src : location.href).href;
  const ISLANDS = (script && script.dataset.islands) || `${BASE}islands.js`;
  // Content > Files: where film frames are looked for when the theme does not have them.
  const FILES = script && script.dataset.files;
  let frames = BASE; // where film frames come from: the theme, or Content > Files (see Scene.onFail)
  // Shopify's CDN converts images to JPEG unless the request accepts AVIF and WebP, as browsers' image requests do.
  const FRAME_REQUEST = { headers: { Accept: 'image/avif,image/webp,*/*' } };
  // Frames copied into the store through Shopify's API start with an 8-byte NKFRAME1 marker, which keeps the CDN
  // from converting them on the way in. Uploaded zips carry plain frames; both kinds load.
  const unwrapFrame = blob => blob.slice(0, 8).text()
    .then(head => (head === 'NKFRAME1' ? blob.slice(8, blob.size, 'image/avif') : blob));
  const EN = root.lang.startsWith('en');
  const T = EN ? {
    calmOn: 'Turn on calm mode', calmOff: 'Turn off calm mode', menu: 'Menu', close: 'Close',
    name: 'your name', contact: 'a phone number or email', join: ' and ',
    fill: list => `Please add ${list}.`, consent: 'Please tick the consent box.',
    failed: 'We couldn’t send your message. Call +48 604 127 765 or write to kontakt@neurokierunek.pl.',
    subject: 'Consultation', lName: 'Name', lContact: 'Contact', lWho: 'Who it is for'
  } : {
    calmOn: 'Włącz spokojny tryb', calmOff: 'Wyłącz spokojny tryb', menu: 'Menu', close: 'Zamknij',
    name: 'imię', contact: 'telefon lub e-mail', join: ' oraz ',
    fill: list => `Uzupełnij ${list}.`, consent: 'Zaznacz zgodę na kontakt.',
    failed: 'Nie udało się wysłać wiadomości. Zadzwoń: +48 604 127 765 albo napisz: kontakt@neurokierunek.pl.',
    subject: 'Konsultacja', lName: 'Imię', lContact: 'Kontakt', lWho: 'Kogo dotyczy'
  };
  const $ = (s, el = document) => el.querySelector(s);
  const $$ = (s, el = document) => Array.from(el.querySelectorAll(s));
  const clamp = (v, a, b) => Math.min(b, Math.max(a, v));
  const smooth = t => t * t * (3 - 2 * t);
  const isPortrait = () => innerHeight >= innerWidth; // same rule as CSS (orientation: portrait)

  let calm = root.classList.contains('calm');

  /* ---------- Frame loader: fetches encoded frames, a few at a time, nearest scene first ----------
     Encoded frames are small (~30–90 KB). Decoded ones are not (~8 MB at 1920 px), so each scene
     only decodes a window of frames around the playhead and releases the rest. */
  const loader = {
    max: 6,
    active: 0,
    scenes: new Set(),
    add(scene) { this.scenes.add(scene); this.pump(); },
    next() {
      let best = null;
      for (const s of this.scenes) {
        if (!s.queue.length) { this.scenes.delete(s); continue; }
        if (!best || s.distance < best.distance) best = s;
      }
      return best;
    },
    pump() {
      while (this.active < this.max) {
        const scene = this.next();
        if (!scene) return;
        const i = scene.queue.shift();
        if (scene.blobs[i]) continue;
        const set = scene.set;
        this.active++;
        const url = scene.url(i);
        fetch(url, FRAME_REQUEST)
          .then(r => { if (!r.ok) throw new Error(String(r.status)); return r.blob(); })
          .then(unwrapFrame)
          .then(b => { if (scene.set === set) scene.onBlob(i, b); }, () => { if (scene.set === set) scene.onFail(i, url); })
          .finally(() => { this.active--; this.pump(); });
      }
    }
  };

  const decodeFrame = 'createImageBitmap' in window
    ? blob => createImageBitmap(blob)
    : blob => new Promise((res, rej) => {
        const img = new Image(), url = URL.createObjectURL(blob);
        img.onload = () => { URL.revokeObjectURL(url); res(img); };
        img.onerror = () => { URL.revokeObjectURL(url); rej(new Error('decode')); };
        img.src = url;
      });
  const release = frame => { if (frame && frame.close) frame.close(); };
  const RADIUS = 10, KEEP = 14; // decode ±10 frames around the playhead, keep ±14

  /* ---------- Fade helper for text beats ---------- */
  const FADE = 0.05;
  function fade(p, a, b) {
    const fin = a <= 0 ? 1 : smooth(clamp((p - (a - FADE)) / FADE, 0, 1));
    const fout = b >= 1 ? 1 : 1 - smooth(clamp((p - b) / FADE, 0, 1));
    return Math.round(Math.min(fin, fout) * 1000) / 1000;
  }

  /* ---------- Scene ---------- */
  class Scene {
    constructor(el) {
      this.el = el;
      this.name = el.dataset.scene;
      this.canvas = $('canvas.film', el);
      this.box = this.canvas; // sized by CSS: the whole stage, or just part of it (process)
      this.ctx = this.canvas.getContext('2d', { alpha: false });
      this.focus = parseFloat(el.dataset.focus || '0.5');
      // data-blur: the beat dissolves as it fades (made for the ink film, which the desk film replaced).
      this.items = $$('[data-in]', el).map(n => ({ n, a: +n.dataset.in, b: +n.dataset.out, o: -1, blur: n.hasAttribute('data-blur') }));
      // data-at: lines that light up in turn and stay visible (the desk film): reached lines are on, the latest is current.
      this.marks = $$('[data-at]', el).map(n => ({ n, at: +n.dataset.at }));
      this.bar = $('.scene-progress span', el);
      // Route map (process section): the line draws itself and a marker walks it.
      this.route = $('.route-line', el);
      if (this.route) {
        this.sketch = $('.route-sketch', el);
        this.marker = $('.route-marker', el);
        this.routeLen = this.route.getTotalLength();
        this.sketchLen = this.sketch.getTotalLength();
        this.stops = $$('[data-r]', el).map(n => ({ n, r: +n.dataset.r, label: n.tagName === 'LI' }));
      }
      this.p = 0;
      this.cur = 0;
      this.distance = Infinity;
      this.set = null;
      this.chooseSet();
    }

    chooseSet() {
      const set = this.el.dataset.set || (isPortrait() ? 'm' : 'd');
      if (set === this.set) return false;
      this.set = set;
      this.n = parseInt(set === 'm' ? this.el.dataset.framesM : this.el.dataset.framesD, 10);
      this.srcW = set === 'm' ? 840 : 1920;
      if (this.bitmaps) this.bitmaps.forEach(release);
      this.blobs = new Array(this.n);    // encoded frames, kept for the whole film
      this.bitmaps = new Array(this.n);  // decoded frames, only near the playhead
      this.decoding = new Set();
      this.queue = [];
      this.queued = false;
      this.fails = 0;
      this.broken = false;
      this.ready = false;
      this.canvas.classList.remove('is-ready');
      this.cur = this.p * (this.n - 1);
      return true;
    }

    url(i) { return `${frames}seq-${this.name}-${this.set}-${String(i + 1).padStart(3, '0')}.avif`; }

    load() {
      if (this.queued || calm || !this.box.clientWidth) return; // hidden windows load nothing
      this.queued = true;
      // Coarse to fine: every 16th frame first, so scrubbing works while the rest arrives.
      const seen = new Uint8Array(this.n);
      const order = [];
      for (const step of [16, 8, 4, 2, 1]) {
        for (let i = 0; i < this.n; i += step) if (!seen[i]) { seen[i] = 1; order.push(i); }
      }
      if (!seen[this.n - 1]) order.push(this.n - 1);
      this.queue = order;
      loader.add(this);
    }

    onBlob(i, blob) {
      this.blobs[i] = blob;
      this.decodeAround();
    }

    // Frames that will not load or decode (e.g. no AVIF support) leave the still poster in place.
    // A frame the theme does not have is tried once more from Content > Files, and so are all frames after it.
    onFail(i, url) {
      if (FILES && url && url.startsWith(BASE)) { frames = FILES; this.queue.unshift(i); loader.add(this); return; }
      if (i === 0 || ++this.fails > 3) { this.queue = []; this.broken = true; }
    }

    // Decode outward from the playhead, release frames that drifted out of reach.
    decodeAround() {
      if (!this.n || this.broken) return;
      const c = Math.round(this.cur);
      for (let i = 0; i < this.n; i++) {
        if (this.bitmaps[i] && (!this.near || Math.abs(i - c) > KEEP)) { release(this.bitmaps[i]); this.bitmaps[i] = null; }
      }
      if (!this.near || calm) return;
      for (let d = 0; d <= RADIUS && this.decoding.size < 3; d++) {
        for (const i of d ? [c + d, c - d] : [c]) {
          if (i < 0 || i >= this.n || this.bitmaps[i] || this.decoding.has(i) || !this.blobs[i] || this.decoding.size >= 3) continue;
          this.decoding.add(i);
          decodeFrame(this.blobs[i]).then(frame => {
            this.decoding.delete(i);
            if (!this.near || calm || Math.abs(i - Math.round(this.cur)) > KEEP) { release(frame); return; }
            this.bitmaps[i] = frame;
            this.dirty = true;
            requestTick();
            this.decodeAround();
          }, () => { this.decoding.delete(i); this.onFail(i); });
        }
      }
    }

    releaseAll() {
      if (!this.bitmaps) return;
      this.bitmaps.forEach(release);
      this.bitmaps = new Array(this.n);
      this.ready = false;
      this.canvas.classList.remove('is-ready');
    }

    resize() {
      const w = this.box.clientWidth, h = this.box.clientHeight;
      if (!w || !h) return;
      // Drawing sharper than ~1.6x the frame size only costs fill-rate.
      const dpr = Math.max(1, Math.min(window.devicePixelRatio || 1, 2, (this.srcW * 1.6) / w));
      const cw = Math.round(w * dpr), ch = Math.round(h * dpr);
      if (this.canvas.width !== cw || this.canvas.height !== ch) {
        this.canvas.width = cw;
        this.canvas.height = ch;
        this.dirty = true;
      }
    }

    measure() {
      const r = this.el.getBoundingClientRect();
      const vh = innerHeight;
      this.top = r.top;
      this.height = r.height;
      this.visible = r.bottom > 0 && r.top < vh;
      this.distance = this.visible ? 0 : (r.top >= vh ? r.top - vh : -r.bottom);
      this.near = r.top < vh * 2.2 && r.bottom > -vh * 0.5;
    }

    update() {
      const span = this.height - innerHeight;
      const p = span > 0 ? clamp(-this.top / span, 0, 1) : 0;
      this.p = p;

      for (const it of this.items) {
        const o = fade(p, it.a, it.b);
        if (o === it.o) continue;
        it.o = o;
        const dir = p < it.a ? 1 : -1;
        it.n.style.opacity = o;
        it.n.style.transform = o >= 1 ? '' : `translate3d(0, ${((1 - o) * 12 * dir).toFixed(2)}px, 0)`;
        if (it.blur) it.n.style.filter = o >= 1 || o <= 0 ? '' : `blur(${((1 - o) * 10).toFixed(1)}px)`;
        it.n.classList.toggle('is-on', o > 0.5);
      }

      if (this.marks.length) {
        let current = null;
        for (const mk of this.marks) { const on = p >= mk.at; mk.n.classList.toggle('is-on', on); if (on) current = mk.n; }
        for (const mk of this.marks) mk.n.classList.toggle('is-current', mk.n === current);
      }

      if (this.route) {
        const r = clamp((p - 0.06) / 0.84, 0, 1);
        this.route.style.strokeDasharray = this.routeLen;
        this.route.style.strokeDashoffset = (this.routeLen * (1 - r)).toFixed(1);
        this.sketch.style.strokeDasharray = this.sketchLen;
        this.sketch.style.strokeDashoffset = (this.sketchLen * (1 - r)).toFixed(1);
        const pt = this.route.getPointAtLength(this.routeLen * r);
        this.marker.setAttribute('transform', `translate(${pt.x.toFixed(1)} ${pt.y.toFixed(1)})`);
        let current = null;
        for (const s of this.stops) {
          const on = r >= s.r - 0.004;
          s.n.classList.toggle('is-on', on);
          if (on && s.label) current = s.n;
        }
        for (const s of this.stops) if (s.label) s.n.classList.toggle('is-current', s.n === current);
      }

      if (this.bar) this.bar.style.transform = `scaleX(${p.toFixed(4)})`;
    }

    nearest(i) {
      if (this.bitmaps[i]) return i;
      for (let d = 1; d < this.n; d++) {
        if (i - d >= 0 && this.bitmaps[i - d]) return i - d;
        if (i + d < this.n && this.bitmaps[i + d]) return i + d;
      }
      return -1;
    }

    blit(img) {
      const c = this.canvas, iw = img.naturalWidth || img.width, ih = img.naturalHeight || img.height;
      const s = Math.max(c.width / iw, c.height / ih);
      const dw = iw * s, dh = ih * s;
      const fx = this.set === 'm' ? 0.5 : this.focus;
      this.ctx.drawImage(img, (c.width - dw) * fx, (c.height - dh) / 2, dw, dh);
    }

    // Returns true while the film is still easing toward the scroll position.
    draw() {
      if (!this.n || !this.box.clientWidth) return false;
      const target = this.p * (this.n - 1);
      const before = this.cur;
      this.cur += (target - this.cur) * 0.14;
      if (Math.abs(target - this.cur) < 0.004) this.cur = target;
      if (this.cur === before && !this.dirty) return false;

      const i0 = Math.floor(this.cur), t = this.cur - i0;
      const a = this.nearest(i0);
      if (a < 0) return this.cur !== target;
      const b = t > 0.02 && i0 + 1 < this.n ? this.nearest(i0 + 1) : -1;

      this.ctx.globalAlpha = 1;
      this.blit(this.bitmaps[a]);
      // Cross-blend neighbouring frames: smoother than the frame count alone allows.
      if (b > a) {
        this.ctx.globalAlpha = t;
        this.blit(this.bitmaps[b]);
        this.ctx.globalAlpha = 1;
      }
      this.dirty = false;
      if (!this.ready) { this.ready = true; this.canvas.classList.add('is-ready'); }
      return this.cur !== target;
    }

    resetStyles() {
      for (const it of this.items) { it.o = -1; it.n.style.opacity = ''; it.n.style.transform = ''; it.n.style.filter = ''; it.n.classList.remove('is-on'); }
      for (const mk of this.marks) mk.n.classList.remove('is-on', 'is-current');
      if (this.bar) this.bar.style.transform = '';
      if (this.route) {
        for (const path of [this.route, this.sketch]) { path.style.strokeDasharray = ''; path.style.strokeDashoffset = ''; }
        this.marker.removeAttribute('transform');
        for (const s of this.stops) s.n.classList.remove('is-on', 'is-current');
      }
    }
  }

  const scenes = $$('[data-scene]').map(el => new Scene(el));

  /* ---------- Scenes without films: the reel strip, the Instagram wall, drifting photos ----------
     Same rules as the films: they only move while the visitor scrolls. Muted previews play only on screen. */
  const wide = matchMedia('(min-width: 761px) and (orientation: landscape)');
  const ease = (p, a, b) => smooth(clamp((p - a) / (b - a), 0, 1));
  const player = $('#player');
  const playerOpen = () => !!(player && player.open);
  function playMuted(v) {
    if (!v || calm || playerOpen()) return;
    if (!v.getAttribute('src')) v.src = v.dataset.src;
    const p = v.play();
    if (p && p.catch) p.catch(() => {});
  }

  // Reels: on wide screens the section pins and scrolling moves the strip sideways.
  // Phones and calm mode get a swipe strip. The reel in focus plays a muted preview.
  class Strip {
    constructor(el) {
      this.el = el;
      this.track = $('.reel-track', el);
      this.cards = $$('[data-reel]', el);
      this.now = $('[data-reel-now]', el);
      this.bar = $('.scene-progress span', el);
      this.active = -1;
      this.x = -1;
      this.overflow = 0;
      this.cards.forEach(c => {
        const v = $('.reel-preview', c);
        v.addEventListener('playing', () => c.classList.add('is-previewing'));
        v.addEventListener('pause', () => c.classList.remove('is-previewing'));
      });
      if ('IntersectionObserver' in window) {
        // The first reel that is fully in the swipe strip is the one in focus.
        const inView = new Set();
        const io = new IntersectionObserver(entries => {
          for (const en of entries) {
            const i = this.cards.indexOf(en.target);
            if (en.isIntersecting) inView.add(i); else inView.delete(i);
          }
          if (!this.pinned && inView.size) this.setActive(Math.min(...inView));
        }, { root: this.track, threshold: 0.75 });
        this.cards.forEach(c => io.observe(c));
      }
      // Keyboard: tabbing to a card that sits off screen scrolls the page to it.
      this.track.addEventListener('focusin', e => {
        if (!this.pinned || !this.overflow) return;
        const li = e.target.closest('.reel');
        if (!li) return;
        const x = clamp((li.offsetLeft + li.offsetWidth / 2 - innerWidth / 2) / this.overflow, 0, 1);
        scrollTo({ top: scrollY + this.el.getBoundingClientRect().top + this.hold + x * this.overflow, behavior: 'auto' });
      });
    }
    get pinned() { return !calm && wide.matches; }
    layout() {
      this.track.style.transform = '';
      this.x = -1;
      if (!this.pinned) { this.el.style.height = ''; this.overflow = 0; return; }
      const last = this.track.lastElementChild;
      const padR = parseFloat(getComputedStyle(this.track).paddingRight) || 0;
      this.overflow = Math.max(0, last.offsetLeft + last.offsetWidth + padR - this.track.clientWidth);
      this.hold = innerHeight * 0.12;
      this.el.style.height = `${Math.round(innerHeight + this.overflow + this.hold * 2)}px`;
    }
    measure() {
      const r = this.el.getBoundingClientRect();
      this.top = r.top;
      this.height = r.height;
      this.visible = r.bottom > 0 && r.top < innerHeight;
    }
    update() {
      if (!this.visible) { this.pause(); return; }
      if (this.pinned) {
        const s = clamp(-this.top, 0, this.height - innerHeight);
        const x = this.overflow ? clamp((s - this.hold) / this.overflow, 0, 1) : 0;
        if (x !== this.x) {
          this.x = x;
          this.track.style.transform = `translate3d(${(-x * this.overflow).toFixed(1)}px, 0, 0)`;
          if (this.bar) this.bar.style.transform = `scaleX(${x.toFixed(4)})`;
          this.setActive(Math.round(x * (this.cards.length - 1)));
        }
      } else if (this.active < 0) {
        this.setActive(0);
      }
      this.resume();
    }
    setActive(i) {
      if (i < 0 || i === this.active) return;
      const prev = this.current();
      if (prev) prev.pause();
      if (this.cards[this.active]) this.cards[this.active].classList.remove('is-active');
      this.active = i;
      this.cards[i].classList.add('is-active');
      if (this.now) this.now.textContent = String(i + 1);
      if (this.visible) playMuted(this.current());
    }
    current() { const c = this.cards[this.active]; return c ? $('.reel-preview', c) : null; }
    pause() { const v = this.current(); if (v && !v.paused) v.pause(); }
    resume() { const v = this.current(); if (v && v.paused) playMuted(v); }
    reset() {
      this.pause();
      this.track.style.transform = '';
      this.el.style.height = '';
      if (this.bar) this.bar.style.transform = '';
      this.x = -1;
    }
  }

  // Instagram wall: three columns slide through a window at different speeds. Video tiles play muted on screen.
  class Wall {
    constructor(el) {
      this.el = el;
      this.win = $('.wall-window', el);
      this.cols = $$('.wall-col', el);
      this.speeds = [0.9, 0.5, 0.75];
      this.videos = $$('video', el);
      this.seen = new Set();
      this.p = -1;
      if ('IntersectionObserver' in window) {
        const io = new IntersectionObserver(entries => {
          for (const en of entries) {
            if (en.isIntersecting) { this.seen.add(en.target); playMuted(en.target); }
            else { this.seen.delete(en.target); en.target.pause(); }
          }
        }, { threshold: 0.35 });
        this.videos.forEach(v => io.observe(v));
      }
    }
    get on() { return !calm && wide.matches; }
    layout() {
      this.cols.forEach(c => { c.style.transform = ''; });
      const h = this.win.clientHeight;
      this.travel = this.cols.map((c, i) => Math.max(0, c.offsetHeight - h) * (this.speeds[i] || 0.6));
      this.p = -1;
    }
    measure() {
      const r = this.win.getBoundingClientRect();
      this.top = r.top;
      this.h = r.height;
      this.visible = r.bottom > 0 && r.top < innerHeight;
    }
    update() {
      if (!this.on || !this.visible) return;
      const p = clamp((innerHeight - this.top) / (innerHeight + this.h), 0, 1);
      if (p === this.p) return;
      this.p = p;
      this.cols.forEach((c, i) => { c.style.transform = `translate3d(0, ${(-p * this.travel[i]).toFixed(1)}px, 0)`; });
    }
    resume() { this.seen.forEach(playMuted); }
    reset() {
      this.cols.forEach(c => { c.style.transform = ''; });
      this.videos.forEach(v => v.pause());
      this.p = -1;
    }
  }

  // Small photos that drift a little against the page (team, the first-conversation band).
  class Drift {
    constructor(el) {
      this.el = el;
      this.items = $$('[data-drift]', el).map(n => ({ n, k: parseFloat(n.dataset.drift) || 0 }));
      this.p = null;
    }
    get on() { return !calm && wide.matches; }
    layout() { if (!this.on) this.reset(); this.p = null; }
    measure() {
      const r = this.el.getBoundingClientRect();
      this.top = r.top;
      this.h = r.height;
      this.visible = r.bottom > 0 && r.top < innerHeight;
    }
    update() {
      if (!this.on || !this.visible) return;
      // -1 as the section comes in at the bottom, +1 as it leaves at the top.
      const p = clamp((innerHeight - this.top) / (innerHeight + this.h), 0, 1) * 2 - 1;
      if (p === this.p) return;
      this.p = p;
      for (const it of this.items) it.n.style.transform = `translate3d(0, ${(-p * it.k * innerHeight).toFixed(1)}px, 0)`;
    }
    reset() { this.items.forEach(it => { it.n.style.transform = ''; }); this.p = null; }
  }

  const strip = $('[data-strip]') ? new Strip($('[data-strip]')) : null;
  const wall = $('[data-wall]') ? new Wall($('[data-wall]')) : null;
  const extras = [
    ...(strip ? [strip] : []),
    ...(wall ? [wall] : []),
    ...$$('[data-drift-root]').map(el => new Drift(el))
  ];

  /* ---------- One loop for every scene, only while something changes ---------- */
  let ticking = false;
  function requestTick() {
    if (!ticking) { ticking = true; requestAnimationFrame(tick); }
  }
  function tick() {
    ticking = false;
    if (calm) return;
    for (const s of scenes) s.measure();          // read layout once…
    for (const x of extras) x.measure();
    let again = false;
    for (const s of scenes) {                      // …then write
      s.update();
      if (s.near) s.load();
      if (s.visible && s.draw()) again = true;
      s.decodeAround();
    }
    for (const x of extras) x.update();
    if (again) requestTick();
  }

  function layoutScenes() {
    for (const s of scenes) {
      if (s.chooseSet() && s.near) s.load();
      s.resize();
      s.dirty = true;
    }
    for (const x of extras) x.layout();
    requestTick();
  }
  wide.addEventListener?.('change', layoutScenes);

  let resizeTimer = 0, lastW = innerWidth, lastH = innerHeight;
  addEventListener('resize', () => {
    // Ignore the small height changes mobile browsers make when the address bar slides.
    if (innerWidth === lastW && Math.abs(innerHeight - lastH) < 120) { requestTick(); return; }
    lastW = innerWidth; lastH = innerHeight;
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(layoutScenes, 140);
  });
  addEventListener('scroll', requestTick, { passive: true });

  /* ---------- Calm mode ---------- */
  const toggles = $$('[data-calm-toggle]');
  function syncToggles() {
    toggles.forEach(b => {
      b.setAttribute('aria-pressed', String(calm));
      if (b.closest('.footer-calm')) b.textContent = calm ? T.calmOff : T.calmOn;
    });
  }
  function sectionInView() {
    const mid = innerHeight * 0.4;
    return $$('main > section').find(s => { const r = s.getBoundingClientRect(); return r.top <= mid && r.bottom > mid; });
  }
  function setCalm(next, remember) {
    if (next === calm) return;
    const anchor = scrollY > 40 ? sectionInView() : null;
    calm = next;
    root.classList.toggle('calm', calm);
    root.classList.toggle('motion', !calm);
    if (remember) { try { localStorage.setItem('nk-calm', calm ? '1' : '0'); } catch (e) {} }
    syncToggles();
    scenes.forEach(s => { s.resetStyles(); if (calm) s.releaseAll(); });
    extras.forEach(x => x.reset());
    // Scene heights change a lot between the two layouts; keep the reader where they were.
    if (anchor) anchor.scrollIntoView({ block: 'start' });
    if (!calm) { layoutScenes(); if (wall) wall.resume(); }
  }
  toggles.forEach(b => b.addEventListener('click', () => setCalm(!calm, true)));

  const reduceQuery = matchMedia('(prefers-reduced-motion: reduce)');
  reduceQuery.addEventListener?.('change', e => {
    let stored = null;
    try { stored = localStorage.getItem('nk-calm'); } catch (err) {}
    if (stored === null) setCalm(e.matches, false);
  });
  syncToggles();

  /* ---------- Header ---------- */
  const header = $('[data-header]');
  let headerTick = false;
  const paintHeader = () => { header.classList.toggle('is-scrolled', scrollY > 24); headerTick = false; };
  addEventListener('scroll', () => { if (!headerTick) { headerTick = true; requestAnimationFrame(paintHeader); } }, { passive: true });
  paintHeader();

  /* ---------- Mobile menu ---------- */
  const navBtn = $('[data-nav-toggle]');
  const menu = $('#menu');
  function setNav(open) {
    navBtn.setAttribute('aria-expanded', String(open));
    root.classList.toggle('nav-open', open);
    $('.nav-toggle-label', navBtn).textContent = open ? T.close : T.menu;
    if (open) $('a', menu).focus();
  }
  navBtn.addEventListener('click', () => setNav(navBtn.getAttribute('aria-expanded') !== 'true'));
  menu.addEventListener('click', e => { if (e.target.closest('a')) setNav(false); });
  addEventListener('keydown', e => {
    if (e.key === 'Escape' && root.classList.contains('nav-open')) { setNav(false); navBtn.focus(); }
  });
  matchMedia('(min-width: 961px)').addEventListener?.('change', e => { if (e.matches) setNav(false); });

  /* ---------- Reveal on enter ---------- */
  const reveals = $$('[data-reveal]');
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver(entries => {
      entries.forEach(e => { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });
    reveals.forEach(el => io.observe(el));
  } else {
    reveals.forEach(el => el.classList.add('is-in'));
  }

  /* ---------- Services: the arch shows the service you are reading ---------- */
  const svcImgs = $$('[data-svc-img]');
  const svcs = $$('.svc');
  function setSvc(i) {
    svcImgs.forEach(img => img.classList.toggle('is-active', +img.dataset.svcImg === i));
    svcs.forEach(s => s.classList.toggle('is-active', +s.dataset.svc === i));
  }
  if ('IntersectionObserver' in window) {
    const sio = new IntersectionObserver(entries => {
      entries.forEach(e => { if (e.isIntersecting) setSvc(+e.target.dataset.svc); });
    }, { rootMargin: '-42% 0px -42% 0px' });
    svcs.forEach(s => sio.observe(s));
  }
  svcs.forEach(s => s.addEventListener('mouseenter', () => setSvc(+s.dataset.svc)));
  setSvc(0);

  /* ---------- Reels: open with sound and a transcript, only on request ---------- */
  if (player && typeof player.showModal === 'function') {
    root.classList.add('has-player');
    const pv = $('video', player);
    const pTitle = $('#player-title', player), pMeta = $('.player-meta', player);
    const pText = $('.player-transcript', player), pIg = $('.player-ig', player);
    let opener = null, closing = 0;

    $$('[data-play]').forEach(a => a.addEventListener('click', e => {
      e.preventDefault();
      const li = a.closest('[data-reel]');
      const img = $('img', a);
      opener = a;
      $$('.reel-preview, .wall video').forEach(v => v.pause());
      pTitle.innerHTML = $('.reel-title', li).innerHTML;
      // the card's own line: who is speaking, with her small photo, and the length
      pMeta.replaceChildren(...[...$('.reel-meta', li).childNodes].map(n => n.cloneNode(true)));
      const tr = $('.transcript p', li);
      pText.innerHTML = tr ? `<p>${tr.innerHTML}</p>` : '';
      pIg.href = li.dataset.ig;
      pv.poster = img.currentSrc || img.src;
      pv.src = a.href;
      player.classList.remove('is-closing');
      player.showModal();
      root.classList.add('player-open');
      const played = pv.play();
      if (played && played.catch) played.catch(() => {});
    }));

    // Links elsewhere on the page (the flip cards) that open one of the strip's reels.
    document.addEventListener('click', e => {
      const t = e.target.closest && e.target.closest('[data-play-reel]');
      if (!t) return;
      const card = $(`.reel-card[data-reel-slug="${t.dataset.playReel}"]`);
      if (!card) return;
      e.preventDefault();
      card.click();
      opener = t;
    });

    // Closing fades out first (faster than the open), then the dialog closes.
    const close = () => {
      if (!player.open || closing) return;
      player.classList.add('is-closing');
      closing = setTimeout(() => { closing = 0; player.close(); }, reduceQuery.matches ? 0 : 160);
    };
    player.addEventListener('cancel', e => { e.preventDefault(); close(); });
    player.addEventListener('click', e => { if (e.target === player) close(); });
    $('[data-player-close]', player).addEventListener('click', close);
    // "Book a consultation" under a reel: close the video, then go to the form instead of back to the reel.
    let bookTarget = null;
    const bookBtn = $('[data-player-book]', player);
    if (bookBtn) bookBtn.addEventListener('click', e => { e.preventDefault(); bookTarget = $(bookBtn.getAttribute('href')); close(); });
    player.addEventListener('close', () => {
      player.classList.remove('is-closing');
      pv.pause();
      pv.removeAttribute('src');
      pv.removeAttribute('poster');
      pv.load();
      root.classList.remove('player-open');
      if (bookTarget) {
        bookTarget.scrollIntoView({ block: 'start' });
        const heading = $('h2', bookTarget);
        if (heading) { heading.tabIndex = -1; heading.focus({ preventScroll: true }); }
        bookTarget = null;
      } else if (opener) {
        opener.focus({ preventScroll: true });
      }
      if (wall) wall.resume();
      requestTick();
    });
  }

  /* ---------- Names in the text: a small profile card on hover, focus or tap (from template#nk-people) ---------- */
  const people = $('#nk-people');
  if (people) {
    const pop = document.createElement('div');
    pop.className = 'profile-pop';
    pop.id = 'nk-pop';
    pop.setAttribute('role', 'tooltip');
    pop.hidden = true;
    document.body.append(pop);
    let current = null, hideTimer = 0, openedAt = 0;
    const close = () => {
      clearTimeout(hideTimer);
      pop.classList.remove('is-open');
      pop.hidden = true;
      if (current) current.removeAttribute('aria-describedby');
      current = null;
    };
    const open = m => {
      const card = people.content.querySelector(`[data-person="${m.dataset.person}"]`);
      if (!card) return;
      clearTimeout(hideTimer);
      if (current !== m) {
        if (current) current.removeAttribute('aria-describedby');
        pop.replaceChildren(card.cloneNode(true));
        current = m;
        openedAt = performance.now();
        m.setAttribute('aria-describedby', pop.id);
      }
      pop.hidden = false;
      place(m);
      requestAnimationFrame(() => pop.classList.add('is-open'));
    };
    // under the name, or above it near the bottom of the screen; gone once the name scrolls away
    const place = m => {
      const r = m.getBoundingClientRect(), w = pop.offsetWidth, h = pop.offsetHeight;
      if (r.bottom < 0 || r.top > innerHeight) { close(); return; }
      const x = clamp(r.left + r.width / 2 - w / 2, 12, innerWidth - w - 12);
      const y = r.bottom + 10 + h > innerHeight - 12 ? r.top - h - 10 : r.bottom + 10;
      pop.style.left = `${Math.round(x)}px`;
      pop.style.top = `${Math.round(y)}px`;
    };
    let placing = 0;
    const later = () => { clearTimeout(hideTimer); hideTimer = setTimeout(close, 140); };
    // names inside the player dialog sit in the top layer, where the card cannot follow, so they are left out
    const mentionOf = e => e.target.closest && !e.target.closest('dialog') ? e.target.closest('.mention[data-person]') : null;
    document.addEventListener('mouseover', e => { const m = mentionOf(e); if (m) open(m); });
    document.addEventListener('mouseout', e => { const m = mentionOf(e); if (m && !m.contains(e.relatedTarget)) later(); });
    document.addEventListener('focusin', e => { const m = mentionOf(e); if (m) open(m); });
    document.addEventListener('focusout', e => { if (mentionOf(e)) later(); });
    document.addEventListener('click', e => {
      const m = mentionOf(e);
      // a tap also fires the hover and focus that just opened the card, so only a later tap closes it
      if (m) { if (current === m && !pop.hidden && performance.now() - openedAt > 500) close(); else open(m); }
      else if (!pop.contains(e.target)) close();
    });
    pop.addEventListener('mouseenter', () => clearTimeout(hideTimer));
    pop.addEventListener('mouseleave', later);
    addEventListener('scroll', () => {
      if (pop.hidden || placing) return;
      placing = requestAnimationFrame(() => { placing = 0; if (current) place(current); });
    }, { passive: true });
    document.addEventListener('keydown', e => { if (e.key === 'Escape' && !pop.hidden) close(); });
  }

  /* ---------- Liquid glass: on a desktop, Chromium bends the film under the rim of [data-lens] cards ---------- */
  // Only Chromium reads SVG filters in backdrop-filter; elsewhere the card keeps its CSS glass (tint, frost and rim).
  // The filter only bends; the frost layer over it (css/style.css) keeps to the middle, which costs no frame time,
  // where one filter that did both doubled it.
  const lenses = $$('[data-lens]');
  if (lenses.length && navigator.userAgentData && matchMedia('(min-width: 961px) and (pointer: fine)').matches) {
    const NS = 'http://www.w3.org/2000/svg';
    const defs = document.createElementNS(NS, 'svg');
    defs.setAttribute('aria-hidden', 'true');
    defs.style.cssText = 'position:absolute;width:0;height:0;overflow:hidden';
    document.body.append(defs);
    // A picture the size of the card: R and G give each pixel of the rim the direction of the edge. With a negative
    // scale the rim shows the film from further out, most at the very edge, the way a thick glass edge bends what is
    // behind it; past the bevel nothing moves.
    const bendMap = (w, h, r, bezel) => {
      const c = document.createElement('canvas');
      c.width = w; c.height = h;
      const x = c.getContext('2d'), img = x.createImageData(w, h);
      for (let j = 0; j < h; j++) for (let i = 0; i < w; i++) {
        const px = i + .5 - w / 2, py = j + .5 - h / 2;
        const qx = Math.abs(px) - (w / 2 - r), qy = Math.abs(py) - (h / 2 - r);
        let nx = 0, ny = 0, inside;
        if (qx > 0 && qy > 0) { const l = Math.hypot(qx, qy); inside = r - l; nx = qx / l; ny = qy / l; }
        else if (qx > qy) { inside = r - qx; nx = 1; }
        else { inside = r - qy; ny = 1; }
        const m = (1 - clamp(inside / bezel, 0, 1)) ** 1.6, k = (j * w + i) * 4;
        img.data[k] = 128 - Math.sign(px) * nx * m * 127;
        img.data[k + 1] = 128 - Math.sign(py) * ny * m * 127;
        img.data[k + 2] = 128;
        img.data[k + 3] = 255;
      }
      x.putImageData(img, 0, 0);
      return c.toDataURL();
    };
    lenses.forEach((el, n) => {
      const f = document.createElementNS(NS, 'filter');
      f.id = `nk-lens-${n}`;
      Object.entries({ x: 0, y: 0, width: '100%', height: '100%', 'color-interpolation-filters': 'sRGB' }).forEach(([k, v]) => f.setAttribute(k, v));
      f.innerHTML = '<feImage result="bend" preserveAspectRatio="none"/>'
        + '<feDisplacementMap in="SourceGraphic" in2="bend" scale="-72" xChannelSelector="R" yChannelSelector="G"/>';
      defs.append(f);
      const map = $('feImage', f);
      let size = '', timer = 0;
      const draw = () => {
        const w = el.offsetWidth, h = el.offsetHeight;
        if (!w || !h || `${w}x${h}` === size) return;
        size = `${w}x${h}`;
        const r = Math.min(parseFloat(getComputedStyle(el).borderTopLeftRadius) || 0, w / 2, h / 2);
        map.setAttribute('href', bendMap(w, h, r, Math.min(44, w / 5, h / 5)));
        el.style.setProperty('--lens', `url(#${f.id})`);
        el.classList.add('is-lens');
      };
      new ResizeObserver(() => { clearTimeout(timer); timer = setTimeout(draw, size ? 150 : 0); }).observe(el);
    });
  }

  /* ---------- Contact form: Shopify sends it; it is checked here first ----------
     Its fields are named contact[...] for Shopify, so they are found by their place in the form. */
  const form = $('#form');
  const field = form ? {
    name: $('#f-name', form), contact: $('#f-contact', form), msg: $('#f-msg', form),
    consent: $('.consent input', form), who: $$('.who input', form), replyTo: $('[data-reply-to]', form)
  } : null;
  if (form) {
    const err = $('.form-error', form);
    const doneBox = $('.form-done');
    // Sent: Shopify shows the page again with the thank-you note in place of the form.
    if (form.hidden && doneBox && !doneBox.hidden) {
      requestAnimationFrame(() => { doneBox.scrollIntoView({ block: 'center' }); doneBox.focus({ preventScroll: true }); });
    }

    // Capture phase on window: an incomplete form stops here, before any of Shopify's own submit handlers.
    addEventListener('submit', e => {
      if (e.target !== form) return;
      const name = field.name.value.trim();
      const contact = field.contact.value.trim();
      const missing = [];
      if (!name) missing.push(T.name);
      if (!contact) missing.push(T.contact);
      const consent = field.consent.checked;
      if (missing.length || !consent) {
        e.preventDefault();
        e.stopImmediatePropagation();
        const parts = [];
        if (missing.length) parts.push(T.fill(missing.join(T.join)));
        if (!consent) parts.push(T.consent);
        err.textContent = parts.join(' ');
        err.hidden = false;
        (!name ? field.name : !contact ? field.contact : field.consent).focus();
        return;
      }
      err.hidden = true;
      // Shopify replies to an e-mail address; a phone number travels in the message itself.
      if (field.replyTo) field.replyTo.value = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(contact) ? contact : field.replyTo.defaultValue;
    }, true);
  }

  /* ---------- Booking links: each one lands on the form already set for who it is for ---------- */
  $$('[data-book]').forEach(a => a.addEventListener('click', () => {
    if (!form) return;
    const who = a.dataset.who && field.who.find(r => r.value === a.dataset.who);
    if (who) who.checked = true;
    const msg = field.msg;
    if (a.dataset.msg && msg && !msg.value.trim()) msg.value = a.dataset.msg;
  }));

  // Phones and tablets: a booking bar appears once the opening scene is behind you, and steps aside at the form.
  const bar = $('[data-book-bar]');
  if (bar) {
    const contact = form && form.closest('section');
    let atContact = false, barTick = false;
    const paintBar = () => { barTick = false; bar.classList.toggle('is-on', scrollY > innerHeight * 0.9 && !atContact); };
    if (contact && 'IntersectionObserver' in window) {
      new IntersectionObserver(es => { atContact = es[0].isIntersecting; paintBar(); }, { threshold: 0.02 }).observe(contact);
    }
    addEventListener('scroll', () => { if (!barTick) { barTick = true; requestAnimationFrame(paintBar); } }, { passive: true });
    paintBar();
  }

  /* ---------- React Bits islands (flip cards, service panels): one small bundle, loaded when close ---------- */
  const islandHosts = $$('[data-causes], [data-services]');
  if (islandHosts.length) {
    let islandsLoaded = false;
    const loadIslands = () => { if (!islandsLoaded) { islandsLoaded = true; import(ISLANDS).catch(() => {}); } };
    if ('IntersectionObserver' in window) {
      const iio = new IntersectionObserver(es => { if (es.some(en => en.isIntersecting)) { iio.disconnect(); loadIslands(); } }, { rootMargin: '800px 0px' });
      islandHosts.forEach(h => iio.observe(h));
    } else {
      loadIslands();
    }
  }

  /* ---------- Start ---------- */
  layoutScenes();
  if (!calm && scenes[0]) scenes[0].load(); // the opening film starts loading right away
})();
